import * as React from 'react'
import { reportCategoryPageClick } from '../../../../../common/analytics/categoryPageAnalytics'

import * as styles from './cardDetails.module.css'

interface IProps {
  title: string
  author: string
  categoryName?: string
}

const CardDetails = ({ title, author, categoryName }: IProps) => (
  <div className={styles.details}>
    <div className={styles.content}>
      <span className={styles.title}>{title}</span>
      <br />
      <span className={styles.authorAndCategory}>
        By{' '}
        <span
          className={styles.author}
          onClick={reportCategoryPageClick(`authorlink_${author}`)}
        >
          {author}
        </span>{' '}
        {categoryName && (
          <span>
            in <b>{categoryName}</b>
          </span>
        )}
      </span>
    </div>
    <span className={styles.cta}>View</span>
  </div>
)

export default CardDetails
